import { render, staticRenderFns } from "./KnExpenseSubcategories.vue?vue&type=template&id=378bf51c&"
import script from "./KnExpenseSubcategories.vue?vue&type=script&lang=js&"
export * from "./KnExpenseSubcategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports